import { images } from "../../../../constants";
import { DecodedToken, decodeJwtToken } from "../../../../services/tokenService";
import classes from "./Profile.module.scss";
import { useTranslation } from "react-i18next";

function Profile() {
  const { t } = useTranslation();

  const user : DecodedToken | null = decodeJwtToken();

  return (
    <div className="flex flex-row justify-center items-center gap-3 py-2">
      <div className="img-container">
        <img className="w-[50px] h-[50px] rounded-[50%] mt-0" src={images.avt} alt="avatar" />
      </div>
      <div className="info-container">
        <p className="font-bold">
          {user?.name || t("Guest")}
        </p>
        <span className="font-thin text-[#848484]">
          {user?.Roles || t("Guest Role")}
        </span>
      </div>
    </div>
  );
}

export default Profile;
